import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function createMtrStructSub(payload) {
  const { data: raw } = await request.post('/mtr-struct-sub', keysToSnake(payload));
  return parseVer4DetailResponse(raw);
}
